export const baseStyles = {
  imageItemBox: {
    marginBottom: '16px',
    marginRight: '16px',
    width: '298px',
    height: '274px',
    borderRadius: '4px',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    overflow: 'hidden',
  },
  imageContent: {
    width: '100%',
    height: '200px',
    objectFit: 'contain',
  },
};

export const uploadPreviewStyle = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  uploadPreviewContainer: {
    width: '100%',
  },
  uploadTitle: {
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.neutralSecondary,
    textAlign: 'center',
  },
  imagePreviewContainer: {
    marginTop: '16px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    maxHeight: '637px',
    overflowY: 'scroll',
    scrollBar: 'none',
    '&::-webkit-scrollbar': {
      width: '0',
      display: 'none',
    },
  },
  imageItemBox: {
    ...baseStyles.imageItemBox,
    backgroundColor: palette.neutralLighterAlt,
  },
  imageItemBoxRight: {
    marginRight: '0',
  },
  imageItemErrBox: {
    backgroundColor: '#FDE7E9', // hardcoded; not exported from fluent/theme package, but is used by fluent ui (see Messaging Colors)
    position: 'relative',
  },
  imageContent: {
    ...baseStyles.imageContent,
  },
  imageName: {
    marginTop: '12px',
    marginLeft: '18px',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.neutralPrimary,
    width: '206px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  progressBox: {
    margin: '0 18px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  progressLine: {
    marginTop: '8px',
    width: '206px',
    height: '2px',
    backgroundColor: palette.neutralLight,
    overflow: 'hidden',
  },
  statusIcon: {
    fontFamily: iconFontFamily,
    lineHeight: '16px',
    fontSize: 16,
    verticalAlign: 'middle',
  },
  completeIcon: {
    color: palette.green,
    display: 'block',
    '&:before': {
      content: '"\\EC61"',
    },
    transition: 'all 0.6s ease',
  },
  ongoingIcon: {
    color: palette.themePrimary,
    '&:before': {
      content: '"\\E898"',
    },
  },
  errorIcon: {
    position: 'absolute',
    bottom: '32px',
    right: '18px',
    color: '#A80000', // hardcoded; not exported from fluent/theme package, but is used by fluent ui (see Messaging Colors)
    '&:before': {
      content: '"\\EA39"',
    },
  },
  errorMsg: {
    marginTop: '8px',
    fontFamily: 'Segoe UI',
    fontSize: '12px',
    lineHeight: '16px',
    color: '#A80000', // hardcoded; not exported from fluent/theme package, but is used by fluent ui (see Messaging Colors)
    marginLeft: '18px',
  },
  imageSize: {
    marginTop: '2px',
    marginLeft: '18px',
    fontFamily: 'Segoe UI',
    fontSize: '12px',
    lineHeight: '16px',
  },
});
